const TEXTURES = {
  CREAM: 'Cream',
  LIQUID: 'Liquid',
  GEL: 'Gel',
  MASK: 'Mask',
  MIST: 'Mist',
  OIL: 'Oil',
  PASTE: 'Paste',
  BALM: 'Balm',
  SOLID: 'Solid',
  MOUSSE: 'Mousse',
  STRIP: 'Strip',
  PAD: 'Pad',
  SCRUB: 'Scrub',
  SERUM: 'Serum',
  SPRAY: 'Spray',
  POWDER: 'Powder',
  WAX: 'Wax',
};

export default TEXTURES;
